const cookiesAccepted = !!localStorage.getItem('cookiesAccepted');
const cookiesContainer = document.querySelector('#cookies');
const cookiesContent = document.querySelector('#cookies .journal-content-article');
const cookiesAcceptAllBtn = document.querySelector('#accept-all-cookies');
const cookiesDeclineBtn = document.querySelector('#cookies-decline');
const cookiesCloseBtn = document.querySelector('#close-cookies');

function getConsent() {
	const raw = document.cookie.split('; ').find((row) => row.startsWith('cookieConsent='));
	return raw ? JSON.parse(decodeURIComponent(raw.split('=')[1])) : {};
}
function updateControls() {
	Object.entries(getConsent()).forEach(([key, value]) => {
		const checkbox = document.querySelector(`input[type="checkbox"][name="${key}"]`);
		if (checkbox) {
			checkbox.checked = value;
		}
	});
}

function showCookies() {
	updateControls();
	cookiesContainer.classList.remove('d-none');
}

function closeCookies() {
	updateControls();
	cookiesContainer.classList.add('d-none');
}

function setCookie(name, value, days) {
	const expires = new Date(Date.now() + days * 864e5).toUTCString();
	document.cookie = `${name}=${value}; expires=${expires}; path=/`;
	localStorage.setItem('cookiesAccepted', 'true');
}

function applyMatomoConsent(consent) {
	if (typeof _paq !== 'undefined') {
		if (consent.analytics) {
			_paq.push(['rememberConsentGiven']);
		} else {
			_paq.push(['forgetConsentGiven']);
		}
	}
}

function acceptAllCookies() {
	setCookie(
		'cookieConsent',
		JSON.stringify({
			analytics: true,
			functional: true,
		}),
		365
	);
	applyMatomoConsent({ analytics: true });
	closeCookies();
}
function declineCookies() {
	setCookie(
		'cookieConsent',
		JSON.stringify({
			analytics: false,
			functional: false,
		}),
		365
	);
	applyMatomoConsent({ analytics: false });
	closeCookies();
}

if (!cookiesAccepted && cookiesContainer && cookiesContent) {
	cookiesCloseBtn.addEventListener('click', closeCookies);
	cookiesAcceptAllBtn.addEventListener('click', acceptAllCookies);
	cookiesDeclineBtn.addEventListener('click', declineCookies);

	showCookies();
}

function getConsentPreferences() {
	const form = document.getElementById('cookie-preferences');
	return {
		analytics: form.analytics.checked,
		functional: form.functional.checked,
	};
}

document.getElementById('cookie-preferences').addEventListener('submit', function (e) {
	e.preventDefault();
	const consent = getConsentPreferences();
	setCookie('cookieConsent', JSON.stringify(consent), 365);
	applyMatomoConsent(consent);
	closeCookies();
});

document.addEventListener('DOMContentLoaded', () => {
	const toggleBtn = document.querySelector('#edit-cookies');
	if (toggleBtn) {
		cookiesCloseBtn.addEventListener('click', closeCookies);
		cookiesAcceptAllBtn.addEventListener('click', acceptAllCookies);
		cookiesDeclineBtn.addEventListener('click', declineCookies);

		toggleBtn.addEventListener('click', showCookies);
	}
});
